function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M2.3 7.984c-.166 0-.3.132-.3.298v5.4c0 .166.136.297.302.297l9.4-.001a.3.3 0 00.3-.3l-.004-5.393a.3.3 0 00-.3-.3H2.3zM7 10.3a.3.3 0 01.3-.3h3.4a.3.3 0 01.3.3v2.4a.3.3 0 01-.3.3H7.3a.3.3 0 01-.3-.3v-2.4zM14 6v8.005A1.997 1.997 0 0112 16H2c-1.105 0-2-.893-2-1.995V6h14zm-3-4.004V1A1 1 0 0010 0H9a1 1 0 00-1 .999v.997H6V1A1 1 0 005 0H4a1 1 0 00-1 .999v.997H2c-1.105 0-2 .894-2 1.997h14a1.998 1.998 0 00-2-1.997h-1z"
});

function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgCalendar;